import { render, staticRenderFns } from "./evidence.vue?vue&type=template&id=c773f126&scoped=true&"
import script from "./evidence.vue?vue&type=script&lang=js&"
export * from "./evidence.vue?vue&type=script&lang=js&"
import style0 from "./evidence.vue?vue&type=style&index=0&id=c773f126&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c773f126",
  null
  
)

export default component.exports